import { Button, Space, Text } from '@pyt/ui/components'
import { above } from '@pyt/ui/utils/device'
import Link from 'next/link'
import styled, { keyframes } from 'styled-components'

import AppLayout from '../components/AppLayout'
import ContentWrapper from '../components/ContentWrapper'

const Jump = keyframes`
  0% {transform: translate3d(0px, 0px, 0px); animation-timing-function: ease-in;} 
  50% {transform: translate3d(0px, 10px, 0px); animation-timing-function: ease-out;} 
  100% {transform: translate3d(0px, 0px, 0px);} 
  ${above('mobile')} {
    0% {transform: translate3d(50px, 40px, 0px); animation-timing-function: ease-in;} 
    50% {transform: translate3d(50px, 50px, 0px); animation-timing-function: ease-out;} 
    100% {transform: translate3d(50px, 40px, 0px);}
  }
`

const Wrapper = styled(Space)`
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column-reverse;

	height: 100vh;
	background-image: url('https://pyt-images.imgix.net/images/error_pages/moon.png');
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-position: bottom center;
	padding-top: 35px;

	${above('mobile')} {
		background-size: 500px auto;
		background-position: right bottom;
		padding-top: 80px;
		flex-direction: row;
	}

	${above('tablet')} {
		background-size: 627px 201px;
	}

	h1 {
		font-size: 20px;
		line-height: 1.2;
		letter-spacing: -0.3px;
		font-weight: 700;

		${above('mobile')} {
			font-size: 28px;
			line-height: 1.14;
			letter-spacing: -0.5px;
		}
	}

	li {
		margin: 4px 0;
	}
`

const RightCol = styled(Space)`
	width: 100%;
	justify-content: center;

	${above('mobile')} {
		justify-content: flex-start;
		width: 58.333%;
	}
`

const AstronatIcon = styled.div`
	padding: 0;

	i {
		background: url('https://pyt-images.imgix.net/images/web_app/others_bg_v3.png')
			no-repeat;
		display: block;
		width: 155px;
		height: 90px;
		background-size: auto 690px;
		background-position: -178px -288px;
		animation: ${Jump} 4s 0s infinite;
	}

	${above('mobile')} {
		i {
			width: 247px;
			height: 133px;
			background-position: -249px -437px;
			background-size: auto;
			margin: 80px 0 0 40px;
			animation: ${Jump} 2s 0s infinite;
		}
	}
`

const CustomError = ({ statusCode }) => {
	const onClickButton = () => {
		location.href = '/'
	}

	return (
		<AppLayout
			hideFooter
			navbarProps={{
				isTransparent: false,
			}}
		>
			<ContentWrapper>
				<Wrapper
					itemProps={[
						{
							width: ['100%', '41.666%'],
							height: '100%',
							display: 'flex',
							alignItems: ['flex-start', 'center'],
							justifyContent: 'center',
						},
						{
							width: ['100%', '58.333%'],
							height: ['40%', '100%'],
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						},
					]}
					gutter={0}
				>
					<Space
						direction="vertical"
						gutter={[8, 16, 16, 16, 8, 8]}
						textAlign={['center', 'left']}
						alignItems={['center', 'flex-start']}
					>
						<Text>Error code: ({statusCode})</Text>
						<Text as="h1">Oops! We don't do trails to outer space (yet).</Text>
						<Text>
							Have you clicked on a wrong trail? Don't worry, it happens even to
							the best of us. Let's get you back to earth trails. We are still
							the best at it!
						</Text>
						<Button variant="primary" onClick={onClickButton}>
							Let's plan a trip back to earth
						</Button>
						<Text>Or,</Text>
						<Text>
							Checkout our{' '}
							<Link href="/packages">International tour packages</Link>
						</Text>
						<Link href={'"/blog/"'} target="_blank">
							Read the latest from our blog
						</Link>
					</Space>
					<RightCol>
						<AstronatIcon>
							<i />
						</AstronatIcon>
					</RightCol>
				</Wrapper>
			</ContentWrapper>
		</AppLayout>
	)
}

function getInitialProps({ res, err }) {
	let statusCode
	// If the res variable is defined it means nextjs
	// is in server side
	if (res) {
		statusCode = res.statusCode
	} else if (err) {
		// if there is any error in the app it should
		// return the status code from here
		statusCode = err.statusCode
	} else {
		// Something really bad/weird happen and status code
		// cannot be determined.
		statusCode = null
	}
	return { statusCode }
}

CustomError.getInitialProps = getInitialProps

export default CustomError
